import { useEffect, useState } from 'react';
import axios from 'axios';
import MainURL from '../../../MainURL';

/** 가져온 공고의 잠금 정보 (server routers/recruit/AggregatedClaimRouter.js GET /aggregated/info) */
export interface AggregatedInfo {
  kind: string;
  id: number;
  sourceType: 'ORIGINAL' | 'AGGREGATED' | null;
  /** 잠금 설계가 적용되는 가져온 공고 (잠금 도입 이후 수집분) */
  managed: boolean;
  claimStatus: 'NOT_APPLICABLE' | 'UNCLAIMED' | 'CLAIM_PENDING' | 'CLAIMED' | 'REJECTED' | null;
  /** 지원자·관리 기능이 잠긴 상태 (미선점) */
  locked: boolean;
  /** ONSITE: 사이트 지원 즉시 전달 · RESERVE: 교회 인수 시 전달 · EXTERNAL: 원문으로 지원 */
  applyMode: 'ONSITE' | 'RESERVE' | 'EXTERNAL';
  /** EXPIRED(30일 미선점) · REJECTED(삭제 요청) */
  unpublished: string | null;
  viewCount: number;
  interestCount: number;
  sourceBoard?: string;
  sourceUrl?: string;
  expiresAt?: string | null;
  claimedAt?: string | null;
  claimable?: boolean;
  knownEmailHint?: string | null;
  isOwner: boolean;
  title: string;
  church: string;
}

/** 공고 상세 진입 시 잠금 정보를 받고 조회수를 1 올린다 (같은 IP 6시간에 1회 — 서버에서 판정) */
export function useAggregatedInfo(kind: string | null, id: string | null, countView = true) {
  const [info, setInfo] = useState<AggregatedInfo | null>(null);

  useEffect(() => {
    if (!kind || !id) return;
    let alive = true;
    const load = () => axios.get(`${MainURL}/aggregated/info/${kind}/${id}`)
      .then(res => { if (alive && res.data.success) setInfo(res.data as AggregatedInfo); })
      .catch(() => { if (alive) setInfo(null); });
    if (countView) {
      axios.post(`${MainURL}/aggregated/view/${kind}/${id}`).catch(() => {}).finally(load);
    } else {
      load();
    }
    return () => { alive = false; };
  }, [kind, id, countView]);

  return info;
}
